import { VStack } from '@genial/components';
import { Spacing } from '@genial/design-tokens';
import { useBreakpointValue } from '@genial/utils';
import { Box } from 'native-base';
import React from 'react';

import { SkeletonItemDesktop } from './desktop';
import { SkeletonItemMobile } from './mobile';
import { SkeletonItemTablet } from './tablet';

interface SkeletonItemProps {
  itemsCount?: number;
}

export const SkeletonItem: React.FC<SkeletonItemProps> = ({ itemsCount = 1 }) => {
  const skeleton = useBreakpointValue({
    base: <SkeletonItemMobile />,
    sm: <SkeletonItemTablet />,
    lg: <SkeletonItemDesktop />,
  });

  const data = Array.from({ length: itemsCount }, (_, i) => i);

  return (
    <VStack divider={<Box py={Spacing['inline.quarck']} />} pb={Spacing['inset.nano']}>
      {data.map((item) => (
        <Box key={item.toString()}>{skeleton}</Box>
      ))}
    </VStack>
  );
};
